// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-6a97ab15]{background-color:var(--v-primary-base)!important;border-radius:50px;color:#fff}.single-domain .v-menu[data-v-6a97ab15]{display:none!important}.single-domain .v-card[data-v-6a97ab15]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
